export const PAGE_TYPES = {
  ENTRY_PAGE: 'EntryPage',
  SEARCH_PAGE: 'SearchIdeaPage',
  ESTIMATE_PAGE: 'TrafficEstimatePage',
};

export const PAGE_URL_HASH = {
  [PAGE_TYPES.ENTRY_PAGE]: '#start',
  [PAGE_TYPES.SEARCH_PAGE]: '#search',
  [PAGE_TYPES.ESTIMATE_PAGE]: '#estimate',
};

/*
  controlId for input, picker, etc.
  GROUP: group of inputs in one control (picker)
  e.g. KEYWORD_FILTERS_GROUP contains AVERAGE_MONTHLY_SEARCH, SUGGESTED_BID, ...
*/
export const CONTROL_TYPES = {
  SEARCH_IDEA_PRODUCTS: 'SearchIdeaProducts',
  SEARCH_VOLUME_PRODUCTS: 'SearchVolumeProducts',
  SEARCH_VOLUME_UPLOAD_PRODUCTS: 'SearchVolumeUploadProducts',
  TRAFFIC_ESTIMATE_KEYWORDS: 'TrafficEstimateKeywords',
  TRAFFIC_ESTIMATE_UPLOAD_KEYWORDS: 'TrafficEstimateUploadKeywords',
  TRAFFIC_ESTIMATE_ADGROUP_KEYWORDS: 'TrafficEstimateAdgroupKeywords',
  TRAFFIC_ESTIMATE_BID: 'TrafficEstimateBid',
  TRAFFIC_ESTIMATE_BUDGET: 'TrafficEstimateBudget',
  LANDING_PAGE: 'LandingPage',
  CATEGORY: 'Category',
  DATE_RANGE: 'DateRange',
  NETWORK: 'Network',
  LANGUAGE: 'Language',
  LOCATION: 'Location',
  LOCATION_LD: 'LocationLanguageDecoupling',
  LOCATION_LEVEL: 'LocationLevel',
  SEARCH_VOLUME_CHART_TYPE: 'SearchVolumeChartType',
  KEYWORD_FILTERS_GROUP: 'KeywordFilters',
  AVERAGE_MONTHLY_SEARCH: 'AverageSearchVolume',
  SUGGESTED_BID: 'SuggestedBid',
  AD_IMPRESSION_SHARE: 'AdImpressionShare',
  COMPETITION: 'Competition',
  ACCOUNT_KEYWORD_DEDUPE: 'EnableAccountKeywordDedupe',
  INCLUDED_KEYWORD: 'IncludedKeyword',
  NEGATIVE_KEYWORD: 'NegativeKeyword',
};

export const MONITORED_CONTROL_TYPES = [
  CONTROL_TYPES.DATE_RANGE,
  CONTROL_TYPES.NETWORK,
  CONTROL_TYPES.LANGUAGE,
  CONTROL_TYPES.LOCATION,
  CONTROL_TYPES.LOCATION_LD,
  CONTROL_TYPES.KEYWORD_FILTERS_GROUP,
  CONTROL_TYPES.ACCOUNT_KEYWORD_DEDUPE,
  CONTROL_TYPES.INCLUDED_KEYWORD,
  CONTROL_TYPES.NEGATIVE_KEYWORD,
  CONTROL_TYPES.TRAFFIC_ESTIMATE_ADGROUP_KEYWORDS,
];

export const IDEA_DATE_RANGE_DATA_TYPE = {
  SEARCH_VOLUME: 'SearchVolumeData',
};

export const URL_OPTION_TYPES = {
  DOMAIN: 'Domain',
  PAGE: 'PageContent',
};

export const LANGUAGE_TYPES = {
  ENGLISH: 'English',
  FRENCH: 'French',
  GERMAN: 'German',
  SPANISH: 'Spanish',
  TRADITIONAL_CHINESE: 'Chinese',
  DUTCH: 'Dutch',
  DANISH: 'Danish',
  SWEDISH: 'Swedish',
  NORWEGIAN: 'Norwegian',
  FINNISH: 'Finnish',
  ITALIAN: 'Italian',
  PORTUGUESE: 'Portuguese',
  POLISH: 'Polish',
  GREEK: 'Greek',
  CZECH: 'Czech',
  ROMANIAN: 'Romanian',
  HUNGARIAN: 'Hungarian',
  SLOVAK: 'Slovak',
  MALTESE: 'Maltese',
  BULGARIAN: 'Bulgarian',
  CROATIAN: 'Croatian',
  LITHUANIAN: 'Lithuanian',
  SLOVENIAN: 'Slovenian',
  ESTONIAN: 'Estonian',
  LATVIAN: 'Latvian',
  ALBANIAN: 'Albanian',
  BOSNIAN: 'Bosnian',
  ICELANDIC: 'Icelandic',
  MACEDONIAN: 'Macedonian',
  SERBIAN: 'Serbian',
  TURKISH: 'Turkish',
  JAPANESE: 'Japanese',
  ARABIC: 'Arabic',
  HEBREW: 'Hebrew',
  RUSSIAN: 'Russian',
  SIMPLIFIED_CHINESE: 'SimplifiedChinese',
  TAGALOG: 'Tagalog',
  VIETNAMESE: 'Vietnamese',
  THAI: 'Thai',
  MALAY: 'Malay',
  INDONESIAN: 'Indonesian',
  HINDI: 'Hindi',
};

export const NETWORK_TYPES = {
  ALL: 'All', // OWNED_AND_OPERATED + SYNDICATION
  OWNED_AND_OPERATED: 'OwnedAndOperated',
  SYNDICATION: 'Syndication',
};

export const OPERATOR_TYPES = {
  START: 'Start',
  END: 'End',
};

export const KEYWORD_FILTER_TEXT = {
  [CONTROL_TYPES.AVERAGE_MONTHLY_SEARCH]: _TL_('Average monthly searches'),
  [CONTROL_TYPES.SUGGESTED_BID]: _TL_('Suggested bid'),
  [CONTROL_TYPES.AD_IMPRESSION_SHARE]: _TL_('Ad impression share'),
  [CONTROL_TYPES.COMPETITION]: _TL_('Competition'),
};

export const KEYWORD_FILTER_WITH_RANGE_TYPES = [
  CONTROL_TYPES.AVERAGE_MONTHLY_SEARCH,
  CONTROL_TYPES.SUGGESTED_BID,
  CONTROL_TYPES.AD_IMPRESSION_SHARE,
];

export const COMPETITION_LEVEL_TYPES = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const GRID_TYPES = {
  ADGROUP_IDEA: 'AdgroupIdeaGrid',
  SEARCH_TERM: 'SearchTermGrid',
  KEYWORD_IDEA_OUTER: 'KeywordIdeaOuterGrid',
  KEYWORD_IDEA_INNER: 'KeywordIdeaInnerGrid',
  ADGROUP_ESTIMATE: 'AdgroupEstimateGrid',
  KEYWORD_ESTIMATE_OUTER: 'KeywordEstimateOuterGrid',
  KEYWORD_ESTIMATE_INNER: 'KeywordEstimateInnerGrid',
  DEVICE_ESTIMATE: 'DeviceEstimateGrid',
  LOCATION_ESTIMATE: 'LocationEstimateGrid',
};

export const GRID_LEVELS = {
  ADGROUP: 'Adgroup',
  KEYWORD: 'Keyword',
  INNER_KEYWORD: 'InnerKeyword',
  ADGROUP_ESTIMATE: 'AdGroupTrafficEstimate',
  KEYWORD_ESTIMATE: 'KeywordTrafficEstimate',
  INNER_KEYWORD_ESTIMATE: 'InnerKeywordEstimate',
  DEVICE_ESTIMATE: 'DeviceTrafficEstimate',
  LOCATION_ESTIMATE: 'LocationTrafficEstimate',
};

export const GRID_LEVEL_TYPE_MAPPING = {
  [GRID_LEVELS.ADGROUP]: GRID_TYPES.ADGROUP_IDEA,
  [GRID_LEVELS.ADGROUP_ESTIMATE]: GRID_TYPES.ADGROUP_ESTIMATE,
  [GRID_LEVELS.KEYWORD_ESTIMATE]: GRID_TYPES.KEYWORD_ESTIMATE_OUTER,
  [GRID_LEVELS.DEVICE_ESTIMATE]: GRID_TYPES.DEVICE_ESTIMATE,
  [GRID_LEVELS.LOCATION_ESTIMATE]: GRID_TYPES.LOCATION_ESTIMATE,
};

export const INNER_GRID_LEVEL_TYPE_MAPPING = {
  [GRID_LEVELS.ADGROUP]: GRID_TYPES.KEYWORD_IDEA_INNER,
  [GRID_LEVELS.ADGROUP_ESTIMATE]: GRID_TYPES.KEYWORD_ESTIMATE_INNER,
};

export const ADGROUP_ESTIMATE_COLUMNS = {
  AVERAGE_CPC: 'AdGroupEstimatedTraffic/AverageCPC',
  AVERAGE_POSITION: 'AdGroupEstimatedTraffic/AveragePosition',
  CLICK: 'AdGroupEstimatedTraffic/Clicks',
  COST: 'AdGroupEstimatedTraffic/TotalCost',
  CTR: 'AdGroupEstimatedTraffic/CTR',
  IMPRESSION: 'AdGroupEstimatedTraffic/Impressions',
};

export const KEYWORD_ESTIMATE_COLUMNS = {
  AVERAGE_CPC: 'KeywordEstimatedTraffic/AverageCPC',
  AVERAGE_POSITION: 'KeywordEstimatedTraffic/AveragePosition',
  CLICK: 'KeywordEstimatedTraffic/Clicks',
  COST: 'KeywordEstimatedTraffic/TotalCost',
  CTR: 'KeywordEstimatedTraffic/CTR',
  IMPRESSION: 'KeywordEstimatedTraffic/Impressions',
};

export const DEVICE_ESTIMATE_COLUMNS = {
  AVERAGE_CPC: 'Traffic/AverageCPC',
  AVERAGE_POSITION: 'Traffic/AveragePosition',
  CLICK: 'Traffic/Clicks',
  COST: 'Traffic/TotalCost',
  CTR: 'Traffic/CTR',
  IMPRESSION: 'Traffic/Impressions',
};

export const LOCATION_ESTIMATE_COLUMNS = {
  AVERAGE_CPC: 'Traffic/AverageCPC',
  AVERAGE_POSITION: 'Traffic/AveragePosition',
  CLICK: 'Traffic/Clicks',
  COST: 'Traffic/TotalCost',
  CTR: 'Traffic/CTR',
  IMPRESSION: 'Traffic/Impressions',
};

export const GRID_COLUMN_MAPPING = {
  [GRID_TYPES.ADGROUP_ESTIMATE]: ADGROUP_ESTIMATE_COLUMNS,
  [GRID_TYPES.KEYWORD_ESTIMATE_OUTER]: KEYWORD_ESTIMATE_COLUMNS,
  [GRID_TYPES.KEYWORD_ESTIMATE_INNER]: KEYWORD_ESTIMATE_COLUMNS,
  [GRID_TYPES.DEVICE_ESTIMATE]: DEVICE_ESTIMATE_COLUMNS,
  [GRID_TYPES.LOCATION_ESTIMATE]: LOCATION_ESTIMATE_COLUMNS,
};

// MT consts start
export const IDEA_ATTRIBUTE_TYPES = {
  UNKNOWN: 'Unknown',
  KEYWORD: 'Keyword',
  KEYWORDS: 'Keywords',
  GROUP_INFO: 'GroupInfo',
  LANDING_PAGE: 'LandingPage',
  CATEGORY: 'Category',
  SOURCE: 'Source',
  DUPLICATE_SOURCE: 'DuplicateSource',
  RELEVANCE: 'Relevance',
  AVERAGE_SEARCH_VOLUME: 'AverageSearchVolume',
  SEARCH_VOLUME_TREND: 'SearchVolumeTrend',
  SUGGESTED_BID: 'SuggestedBid',
  COMPETITION: 'Competition',
  DEVICE: 'Device',
  LOCATION: 'Location',
  AD_IMPRESSION_SHARE: 'AdImpressionShare',
  MARKET_LEADER_AD_IMPRESSION_SHARE: 'MarketLeaderAdImpressionShare',
  COMPETITOR_AD_IMPRESSION_SHARE: 'CompetitorAdImpressionShare',
};

export const LANDSCAPE_TYPES = {
  BID: 'Bid',
  SCALE: 'Scale',
};
// MT consts end

export const SECTION_TYPES = {
  SEARCH_IDEA: 'searchIdea',
  SEARCH_IDEA_NEW: 'searchIdeaNew',
  SEARCH_IDEA_LD: 'searchIdeaLD',
  SEARCH_VOLUME: 'searchVolume',
  SEARCH_VOLUME_LD: 'searchVolumeLD',
  TRAFFIC_ESTIMATE: 'trafficEstimate',
};

export const SECTION_TEXT = {
  [SECTION_TYPES.SEARCH_IDEA]: _TL_('Search for new keywords using a phrase or website'),
  [SECTION_TYPES.SEARCH_IDEA_LD]: _TL_('Search for new keywords using a phrase or website'),
  [SECTION_TYPES.SEARCH_VOLUME]: _TL_('Get search volume data and trends'),
  [SECTION_TYPES.SEARCH_VOLUME_LD]: _TL_('Get search volume data and trends'),
  [SECTION_TYPES.TRAFFIC_ESTIMATE]: _TL_('Get performance and cost estimates'),
};

export const SECTION_INPUT_ERROR_TEXT = {
  [SECTION_TYPES.SEARCH_IDEA]: _TL_('You must enter at least one keyword or website.'),
  [SECTION_TYPES.SEARCH_IDEA_LD]: _TL_('You must enter at least one keyword or website.'),
  [SECTION_TYPES.SEARCH_VOLUME]: _TL_('You must enter at least one keyword.'),
  [SECTION_TYPES.SEARCH_VOLUME_LD]: _TL_('You must enter at least one keyword.'),
  [SECTION_TYPES.TRAFFIC_ESTIMATE]: _TL_('You must enter at least one keyword.'),
};

export const SECTION_EXTRA_INPUT_ERROR_TEXT = {
  [SECTION_TYPES.SEARCH_VOLUME]: _TL_('Please choose only one option.'),
  [SECTION_TYPES.SEARCH_VOLUME_LD]: _TL_('Please choose only one option.'),
  [SECTION_TYPES.TRAFFIC_ESTIMATE]: _TL_('Please choose only one option.'),
};

export const SECTION_BUTTON_TEXT = {
  [SECTION_TYPES.SEARCH_IDEA]: _TL_('Get suggestions'),
  [SECTION_TYPES.SEARCH_IDEA_LD]: _TL_('Get suggestions'),
  [SECTION_TYPES.SEARCH_VOLUME]: _TL_('Get search volume'),
  [SECTION_TYPES.SEARCH_VOLUME_LD]: _TL_('Get search volume'),
  [SECTION_TYPES.TRAFFIC_ESTIMATE]: _TL_('Get estimates'),
};

export const GROUP_POSITION = {
  FIRST: 'first',
  SECOND: 'second',
};

export const GROUP_PANEL_TITLE = {
  [GROUP_POSITION.FIRST]: _TL_('Find new keywords'),
  [GROUP_POSITION.SECOND]: _TL_('Plan your budget and get insights for keywords'),
};

export const GROUP_PANEL_TITLE_BETA = {
  [GROUP_POSITION.FIRST]: _TL_('Keyword Planner'),
};

export const PLACE_HOLDER_TEXT = {
  PRODUCT_SERVICE: _TL_('Enter products or services, separated by commas (for example, Seattle, Seattle bakery, bakery).'),
  KEYWORD: _TL_('Enter keywords, separated by commas (for example, Seattle, Seattle bakery, bakery).'),
  URL: _TL_('www.example.com'),
  CATEGORY: _TL_('Enter or select a product category'),
};

export const PLACE_HOLDER_KEYWORD_EXAMPLE = _TL_('Red roses');

export const PLACE_HOLDER_KEYWORD_MATCH_TYPES = {
  BROAD_MATCH: _TL_('For broad match: '),
  PHRASE_MATCH: _TL_('For phrase match: '),
  EXACT_MATCH: _TL_('For exact match: '),
};

export const COMPONENT_TITLE = {
  PRODUCT_SERVICE_INPUT: _TL_('Product or service'),
  SECTION_KEYWORD_INPUT: _TL_('Option 1: Enter keywords'),
  KEYWORD_INPUT: _TL_('Keywords'),
  URL_INPUT: _TL_('Your landing page'),
  CATEGORY_DROPDOWN: _TL_('Your product category'),
  KEYWORD_UPLOAD: _TL_('Option 2: Upload file with keywords'),
};

export const TAXONOMY = {
  NO_RESULT: _TL_('There are no results available'),
  ALL_CATEGORY: _TL_('All Categories'),
};

export const PERIOD_TYPE = {
  UNKNOWN: 'Unknown',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

export const ADGROUP_GRID_KEYWORDS_COLUMN_KEYOWRDS_MAX_COUNT = 12;
export const SEARCH_IDEA_KEYWORD_MAX_COUNT = 200;
export const SEARCH_VOLUME_KEYWORD_MAX_COUNT = 1000;
export const SEARCH_VOLUME_KEYWORD_MAX_COUNT_10K = 10000;
export const TRAFFIC_ESTIMATE_KEYWORD_MAX_COUNT = 1000;
export const KEYWORD_MAX_LENGTH = 100;
export const FILTERED_KEYWORD_MAX_COUNT = 100;

export const SEARCH_VOLUME_CHART_TYPE = {
  SEARCH_VOLUME_TRENDS: 'TotalTrends',
  MOBILE_TRENDS: 'MobileTrends',
  BREAKDOWN_BY_DEVICE: 'BreakdownByDevice',
  BREAKDOWN_BY_LOCATION: 'BreakdownByLocation',
  COMPARE_TO_COMPETITOR_DOMAINS: 'CompareToCompetitorDomains',
  COMPARE_TO_MARKET_LEADER_DOMAINS: 'CompareToMarketLeaderDomains',
};

export const SEARCH_VOLUME_TRENDS_INLINE_CHART_TYPE = 'inlineChart';

export const TRAFFIC_EST_CHART_TYPE = {
  LINE_CHART: 'LineChart',
  DEVICE_PIE_CHART: 'DevicePieChart',
  LOCATION_PIE_CHART: 'LocationPieChart',
};

export const LOCATION_TYPE = {
  COUNTRY: 'Country',
  STATE: 'State',
  SUBGEOGRAPHY: 'SubGeoGraphy',
  METROAREA: 'MetroArea',
  CITY: 'City',
  POSTALCODE: 'PostalCode',
  COUNTY: 'County',
  DMA: 'DMA',
  TARGETED: 'Targeted',
};

export const LOCATION_MT_MAP = { // this const map location type from Campaign MT to Adinsight MT
  SubGeography: LOCATION_TYPE.SUBGEOGRAPHY,
};

export const LOCATION_TYPE_LEVEL = {
  [LOCATION_TYPE.COUNTRY]: 1,
  [LOCATION_TYPE.STATE]: 2,
  [LOCATION_TYPE.SUBGEOGRAPHY]: 2,
  [LOCATION_TYPE.METROAREA]: 3,
  [LOCATION_TYPE.DMA]: 3,
  [LOCATION_TYPE.CITY]: 4,
  [LOCATION_TYPE.POSTALCODE]: 5,
  [LOCATION_TYPE.COUNTY]: 6,
};

export const SEARCH_VOLUME_LOCATION_LEVEL = {
  STATE: LOCATION_TYPE.SUBGEOGRAPHY,
  DMA: LOCATION_TYPE.METROAREA,
  CITY: LOCATION_TYPE.CITY,
  TARGETED: LOCATION_TYPE.TARGETED,
};

export const KEYWORD_PLANNER_PREFERENCE_PREFIX = 'keywordplanner.';
// use new preference id to separate with old UI
export const KEYWORD_PLANNER_PREFERENCES = {
  [CONTROL_TYPES.LOCATION]: `${KEYWORD_PLANNER_PREFERENCE_PREFIX}targeting.locations`,
  [CONTROL_TYPES.LOCATION_LD]: `${KEYWORD_PLANNER_PREFERENCE_PREFIX}targeting.locationsLanguageDecoupling`,
  [CONTROL_TYPES.LANGUAGE]: `${KEYWORD_PLANNER_PREFERENCE_PREFIX}targeting.language`,
  [CONTROL_TYPES.NETWORK]: `${KEYWORD_PLANNER_PREFERENCE_PREFIX}targeting.network`,
  [CONTROL_TYPES.NEGATIVE_KEYWORD]: `${KEYWORD_PLANNER_PREFERENCE_PREFIX}targeting.negativeKeywords`,
};

export const LOCATION_TYPE_WHITE_LIST = [
  LOCATION_TYPE.COUNTRY,
  LOCATION_TYPE.STATE,
  LOCATION_TYPE.SUBGEOGRAPHY,
  LOCATION_TYPE.METROAREA,
  LOCATION_TYPE.CITY,
  LOCATION_TYPE.COUNTY,
];

export const LOCATION_COUNTRYID_WHITE_LIST = [190, 188, 32, 9, 66, 72];

export const LOCATION_COUNTRYCODE_WHITE_LIST = ['AU', 'CA', 'DE', 'FR', 'GB', 'US'];

export const LANGUAGE_LOCAGTIONS = {
  [LANGUAGE_TYPES.FRENCH]: 'Mixed',
  [LANGUAGE_TYPES.ENGLISH]: 'Mixed',
  [LANGUAGE_TYPES.GERMAN]: 'Mixed',
};

export const locationTags = {
  [LOCATION_TYPE.COUNTRY]: _TL_('country/region'),
  [LOCATION_TYPE.STATE]: _TL_('state/province'),
  [LOCATION_TYPE.SUBGEOGRAPHY]: _TL_('SubGeography'),
  [LOCATION_TYPE.METROAREA]: _TL_('metro area'),
  [LOCATION_TYPE.CITY]: _TL_('city'),
  [LOCATION_TYPE.COUNTY]: _TL_('county'),
  [LOCATION_TYPE.DMA]: _TL_('Nielsen DMA'),
};

export const locationOptions = {
  WITHIN: { id: 0, text: _TL_('Within Australia, Canada, France, Germany, United Kingdom, or United States'), isKRT: false },
  NOT_WITHIN: { id: 1, text: _TL_('All available countries/regions'), isKRT: true },
};

export const DEFUALT_LOCATION = {
  [LANGUAGE_TYPES.FRENCH]: {
    id: 66,
    type: 1,
    countryId: 66,
    name: _TL_('France'),
    title: _TL_('France (country/region)'),
  },
  [LANGUAGE_TYPES.ENGLISH]: {
    id: 190,
    type: 1,
    countryId: 190,
    name: _TL_('United States'),
    title: _TL_('United States (country/region)'),
  },
  [LANGUAGE_TYPES.GERMAN]: {
    id: 72,
    type: 1,
    countryId: 72,
    name: _TL_('Germany'),
    title: _TL_('Germany (country/region)'),
  },
};

export const mktToCountryMap = {
  US: {
    id: 190,
    type: 1,
    countryId: 190,
    parentIds: null,
    name: _TL_('United States'),
    title: _TL_('United States (country/region)'),
  },
  UK: {
    id: 188,
    type: 1,
    countryId: 188,
    parentIds: null,
    name: _TL_('United Kingdom'),
    title: _TL_('United Kingdom (country/region)'),
  },
  AU: {
    id: 9,
    type: 1,
    countryId: 9,
    parentIds: null,
    name: _TL_('Australia'),
    title: _TL_('Australia (country/region)'),
  },
  CA: {
    id: 32,
    type: 1,
    countryId: 32,
    parentIds: null,
    name: _TL_('Canada'),
    title: _TL_('Canada (country/region)'),
  },
  FR: {
    id: 66,
    type: 1,
    countryId: 66,
    parentIds: null,
    name: _TL_('France'),
    title: _TL_('France (country/region)'),
  },
  DE: {
    id: 72,
    type: 1,
    countryId: 72,
    parentIds: null,
    name: _TL_('Germany'),
    title: _TL_('Germany (country/region)'),
  },
};

export const mktToLanguageMap = {
  US: LANGUAGE_TYPES.ENGLISH,
  UK: LANGUAGE_TYPES.ENGLISH,
  CA: LANGUAGE_TYPES.ENGLISH,
  AU: LANGUAGE_TYPES.ENGLISH,
  FR: LANGUAGE_TYPES.FRENCH,
  DE: LANGUAGE_TYPES.GERMAN,
};

export const REQUEST_SUPPORTED_LANGUAGES = {
  [LANGUAGE_TYPES.ITALIAN]: {
    prefix: 'it',
    lcid: 1040,
  },
  [LANGUAGE_TYPES.SPANISH]: {
    prefix: 'es',
    lcid: 3082,
  },
  [LANGUAGE_TYPES.PORTUGUESE]: {
    prefix: 'pt',
    lcid: 1046,
  },
  [LANGUAGE_TYPES.TRADITIONAL_CHINESE]: {
    prefix: 'zh',
    lcid: 24,
  },
  [LANGUAGE_TYPES.ENGLISH]: {
    prefix: 'en',
    lcid: 1033,
  },
};

export const LAYOUT_MODE = {
  Expanded: 'expanded',
  Collapsed: 'collapsed',
  Hidden: 'hidden',
};

export const DeviceTypes = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
  Tablet: 'Tablet',
};

export const MATCH_TYPE = {
  EXACT: 'Exact',
  PHRASE: 'Phrase',
  BROAD: 'Broad',
};

export const DATE_RANGE_LAST12MONTH = 11;

export const CsvHeader = {
  Campaign: _TL_('Campaign'),
  AdGroup: _TL_('Ad group'),
  AdGroupByRelevance: _TL_('Ad group (by relevance)'),
  Keyword: _TL_('Keyword'),
  AverageMonthlySearches: _TL_('Average monthly searches'),
  Competition: _TL_('Competition'),
  SuggestedBid: _TL_('Suggested Bid'),
  ImprShare: _TL_('Ad impr. share'),
  MatchType: _TL_('Match Type'),
  Bid: _TL_('Bid'),
  EstimatedClicks: _TL_('Estimated Clicks'),
  EstimatedImpr: _TL_('Estimated Impr.'),
  EstimatedSpend: _TL_('Estimated Spend'),
  EstimatedCTR: _TL_('Estimated CTR'),
  EstimatedAvgCPC: _TL_('Estimated Avg. CPC'),
  EstimatedAvgPosition: _TL_('Estimated Avg. Position'),
  MonthlySearch: [_TL_('Jan'),
    _TL_('Feb'),
    _TL_('Mar'),
    _TL_('Apr'),
    _TL_('May'),
    _TL_('Jun'),
    _TL_('Jul'),
    _TL_('Aug'),
    _TL_('Sep'),
    _TL_('Oct'),
    _TL_('Nov'),
    _TL_('Dec')],
};

export const EST_BUTTON_TYPE = {
  CLICKS: 'ClickRange',
  IMPRESSONS: 'ImpressionRange',
  SPEND: 'CostRange',
};

export const EST_DATA_TYPE = {
  CLICKS: 'Clicks',
  IMPRESSONS: 'Impressions',
  SPEND: 'TotalCost',
  MAXCPC: 'Point',
  SCALED_BID: 'ScalePoint',
};

export const EST_DATA_TYPE_MAP = {
  [EST_BUTTON_TYPE.CLICKS]: EST_DATA_TYPE.CLICKS,
  [EST_BUTTON_TYPE.IMPRESSONS]: EST_DATA_TYPE.IMPRESSONS,
  [EST_BUTTON_TYPE.SPEND]: EST_DATA_TYPE.SPEND,
};

export const EST_DEVICE_DROPDOWN_TYPE = {
  BID: 'Bid',
  DEVICE: 'Device',
};

export const LOG_TYPES = {
  VIEW_LOG: 'keywordplanner/viewlog',
  CHART_VIEW_LOG: 'keywordplanner/chartviewlog',
  EXPLICIT_ADOPTION_LOG: 'keywordplanner/explicitadoptionlog',
  ESTIMATES_CLICK_LOG: 'keywordplanner/estimatesclicklog',
  EXPORT_LOG: 'keywordplanner/exportlog',
  ERROR_LOG: 'keywordplanner/errorlog',
};

export const LOG_ERROR_TYPES = {
  ADOPTION_ERROR: 'adoption error',
};

export const LOG_ACTION_TYPES = {
  VIEW: 'View',
  ACCEPT: 'Acept',
  CLICK: 'Click',
  EXPORT: 'Export',
  ERROR: 'Error',
};

export const LOG_TYPE_ACTION_TYPE_MAPPING = {
  [LOG_TYPES.VIEW_LOG]: LOG_ACTION_TYPES.VIEW,
  [LOG_TYPES.CHART_VIEW_LOG]: LOG_ACTION_TYPES.VIEW,
  [LOG_TYPES.EXPLICIT_ADOPTION_LOG]: LOG_ACTION_TYPES.ACCEPT,
  [LOG_TYPES.ESTIMATES_CLICK_LOG]: LOG_ACTION_TYPES.CLICK,
  [LOG_TYPES.EXPORT_LOG]: LOG_ACTION_TYPES.EXPORT,
  [LOG_TYPES.ERROR_LOG]: LOG_ACTION_TYPES.ERROR,
};

export const LOG_SCENARIOS = {
  [SECTION_TYPES.SEARCH_IDEA]: 'new keywords',
  [SECTION_TYPES.SEARCH_IDEA_LD]: 'new keywords',
  [SECTION_TYPES.SEARCH_VOLUME]: 'search volume',
  [SECTION_TYPES.SEARCH_VOLUME_LD]: 'search volume',
  [SECTION_TYPES.TRAFFIC_ESTIMATE]: 'perf estimation',
};

export const LOG_TAB_OPTIONS = {
  ADGROUP: 'ad group',
  KEYWORD: 'keyword',
  DETAIL: 'detail: ',
};

export const LOG_SORT_BY_OPTIONS = {
  DEFAULT: 'default',
  ADGROUP_RELEVANCE: 'ad group (relevance)',
  SEARCH: 'search',
  COMPETITION: 'competition',
  BID: 'bid',
  IS: 'is',
  ADGROUP: 'ad group',
  MAX_CPC: 'max cpc',
  CLICKS: 'clicks',
  IMPRESSIONS: 'impressions',
  SPEND: 'spend',
  CTR: 'ctr',
  AVG_CPC: 'avg cpc',
};

export const SORTABLE_COLUMN_KEY_LOG_SORT_BY_OPTION_MAPPING = {
  'Idea/Relevance': LOG_SORT_BY_OPTIONS.ADGROUP_RELEVANCE,
  'Idea/AvgSearchs': LOG_SORT_BY_OPTIONS.SEARCH,
  'Idea/Competition': LOG_SORT_BY_OPTIONS.COMPETITION,
  'Idea/SuggestedBid': LOG_SORT_BY_OPTIONS.BID,
  'Idea/AdImprShare': LOG_SORT_BY_OPTIONS.IS,
  AdGroupName: LOG_SORT_BY_OPTIONS.ADGROUP,
  MaxCPC: LOG_SORT_BY_OPTIONS.MAX_CPC,
  [ADGROUP_ESTIMATE_COLUMNS.CLICK]: LOG_SORT_BY_OPTIONS.CLICKS,
  [ADGROUP_ESTIMATE_COLUMNS.IMPRESSION]: LOG_SORT_BY_OPTIONS.IMPRESSIONS,
  [ADGROUP_ESTIMATE_COLUMNS.COST]: LOG_SORT_BY_OPTIONS.SPEND,
  [ADGROUP_ESTIMATE_COLUMNS.CTR]: LOG_SORT_BY_OPTIONS.CTR,
  [ADGROUP_ESTIMATE_COLUMNS.AVERAGE_CPC]: LOG_SORT_BY_OPTIONS.AVG_CPC,
  [KEYWORD_ESTIMATE_COLUMNS.CLICK]: LOG_SORT_BY_OPTIONS.CLICKS,
  [KEYWORD_ESTIMATE_COLUMNS.IMPRESSION]: LOG_SORT_BY_OPTIONS.IMPRESSIONS,
  [KEYWORD_ESTIMATE_COLUMNS.COST]: LOG_SORT_BY_OPTIONS.SPEND,
  [KEYWORD_ESTIMATE_COLUMNS.CTR]: LOG_SORT_BY_OPTIONS.CTR,
  [KEYWORD_ESTIMATE_COLUMNS.AVERAGE_CPC]: LOG_SORT_BY_OPTIONS.AVG_CPC,
};

export const GRID_LEVELS_LOG_TAB_OPTION_MAPPING = {
  [GRID_LEVELS.ADGROUP]: LOG_TAB_OPTIONS.ADGROUP,
  [GRID_LEVELS.KEYWORD]: LOG_TAB_OPTIONS.KEYWORD,
  [GRID_LEVELS.KEYWORD_IDEA_INNER]: LOG_TAB_OPTIONS.DETAIL,
  [GRID_LEVELS.ADGROUP_ESTIMATE]: LOG_TAB_OPTIONS.ADGROUP,
  [GRID_LEVELS.KEYWORD_ESTIMATE]: LOG_TAB_OPTIONS.KEYWORD,
};

export const LOG_TRACKING_ACTIONS = {
  ADD_TO_ESTIMATE: 'add to estimate',
  BACK_TO_ESTIMATE: 'back to estimate',
};

export const LOG_TRACKING_ACTION_TYPE_MAPPING = {
  [LOG_TRACKING_ACTIONS.ADD_TO_ESTIMATE]: LOG_TYPES.ESTIMATES_CLICK_LOG,
  [LOG_TRACKING_ACTIONS.BACK_TO_ESTIMATE]: LOG_TYPES.VIEW_LOG,
};

export const LANDING_PAGE_OPTIONS = {
  K2K: 'K2K',
  D2K: 'D2K',
  U2K: 'U2K',
  All: 'All',
};

export const URL_LENGTH_LIMIT = 2000;

export const CHANNEL_TYPES = {
  KEYWORD_PLANNER_TOOL: 'keyword planner tool',
  CAMPAIGN_CREATION: 'campaign creation',
  ADGROUP_CREATION: 'ad group creation',
  KEYWORD_CREATION: 'keyword creation',
  REPAIR_KEYWORD_CREATION: 'repair keyword creation',
};

export const CHANNEL_TYPES_MAPPING = {
  [CHANNEL_TYPES.KEYWORD_PLANNER_TOOL]: 'KeywordPlannerUI',
  [CHANNEL_TYPES.CAMPAIGN_CREATION]: 'KeywordPlannerLite',
  [CHANNEL_TYPES.ADGROUP_CREATION]: 'KeywordPlannerLite',
  [CHANNEL_TYPES.KEYWORD_CREATION]: 'KeywordPlannerLite',
  [CHANNEL_TYPES.REPAIR_KEYWORD_CREATION]: 'KeywordPlannerLite',
};

export const LOCATION_TARGET_LIMIT = 200;
